import type { ContentPageDetailsStructuredData } from '~/types/TypesFromPortalBackend'

const useJsonLdProductWithAggregateRating = () => {
  const state = useState<ContentPageDetailsStructuredData|null>(() => null)

  const setData = (data: ContentPageDetailsStructuredData|null) => {
    state.value = data
  }

  const getAssembledObject = (): ContentPageDetailsStructuredData|null => {
    return state.value
  }

  return {
    setData,
    getAssembledObject
  }
}

export default useJsonLdProductWithAggregateRating
